import type { AlgoliaHit } from "../types"

export function generateTitleFromSlug(slug: string): string {
  const parts = slug.split("/").filter((p) => p)
  const filename = parts[parts.length - 1] || ""
  return filename
    .replace(/[-_]/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export function extractTitleFromHit(hit: AlgoliaHit): string {
  const firstSubheading = hit.subheadings
    ?.split(" ")
    .slice(0, 5)
    .join(" ")
    .trim()
  const fallbackTitle = firstSubheading || generateTitleFromSlug(hit.slug)
  return hit.h1 || fallbackTitle
}
